import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "device-firmware-list" }
const _hoisted_2 = {
  key: 0,
  class: "not-searched"
}
const _hoisted_3 = { class: "table-scrollbar" }
const _hoisted_4 = { class: "table-header-row" }
const _hoisted_5 = { class: "checkbox-in-grid align-middle" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { colspan: "9" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_table_sort = _resolveComponent("table-sort")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_ResizableList = _resolveComponent("ResizableList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDeviceListLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_ctx.i18n.global.t('pages.common.list.reading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ResizableList, { scrollAreaSelector: ".v-table__wrapper" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  _createElementVNode("th", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.selectAll,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectAll) = $event)),
                        onChange: _ctx.toggleSelectAll,
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onChange"])
                    ])
                  ]),
                  _createElementVNode("th", null, [
                    _createVNode(_component_table_sort, {
                      "column-title": _ctx.i18n.global.t('pages.deviceFirmware.list.operationOffice'),
                      "sort-field": _ctx.sortField.ORDER_BY_OPERATION_OFFICE,
                      "current-sort-field": _ctx.deviceListSort.sort,
                      "current-sort-type": _ctx.deviceListSort.sort_type,
                      onChangeSort: _ctx.changeSort,
                      onToggleSort: _ctx.toggleSort
                    }, null, 8, ["column-title", "sort-field", "current-sort-field", "current-sort-type", "onChangeSort", "onToggleSort"])
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.list.numberPlate')), 1),
                  _createElementVNode("th", null, [
                    _createVNode(_component_table_sort, {
                      "column-title": _ctx.i18n.global.t('pages.deviceFirmware.list.deviceId'),
                      "sort-field": _ctx.sortField.ORDER_BY_DEVICE_ID,
                      "current-sort-field": _ctx.deviceListSort.sort,
                      "current-sort-type": _ctx.deviceListSort.sort_type,
                      onChangeSort: _ctx.changeSort,
                      onToggleSort: _ctx.toggleSort
                    }, null, 8, ["column-title", "sort-field", "current-sort-field", "current-sort-type", "onChangeSort", "onToggleSort"])
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.list.modelNumber')), 1),
                  _createElementVNode("th", null, [
                    _createVNode(_component_table_sort, {
                      "column-title": _ctx.i18n.global.t('pages.deviceFirmware.list.typeNumber'),
                      "sort-field": _ctx.sortField.ORDER_BY_DEVICE_TYPE,
                      "current-sort-field": _ctx.deviceListSort.sort,
                      "current-sort-type": _ctx.deviceListSort.sort_type,
                      onChangeSort: _ctx.changeSort,
                      onToggleSort: _ctx.toggleSort
                    }, null, 8, ["column-title", "sort-field", "current-sort-field", "current-sort-type", "onChangeSort", "onToggleSort"])
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.list.version')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.global.t('pages.deviceFirmware.applyDate')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.devices.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.devices, (device, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_checkbox, {
                            class: "initialism align-middle checkbox-in-grid",
                            label: "",
                            modelValue: this.selectedDevices[this.makeKey(device)],
                            "onUpdate:modelValue": ($event: any) => ((this.selectedDevices[this.makeKey(device)]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(device.operation_office_company_name || '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(device?.vehicle?.number_plate || '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(device.device_id), 1),
                        _createElementVNode("td", null, _toDisplayString(device?.model_number), 1),
                        _createElementVNode("td", null, _toDisplayString(device?.type?.type || '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(device?.firmware?.version || '-'), 1),
                        _createElementVNode("td", null, _toDisplayString(device?.firmware?.activate_date ? _ctx.formatDate(device.firmware.activate_date) : '-'), 1)
                      ]))
                    }), 128))
                  : (!_ctx.isDeviceListLoading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.i18n.global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1))
  ]))
}